import { gql } from '@apollo/client';

import { GOAL_FRAGMENT } from './goal';

export const USER_FRAGMENT = gql`
  fragment UserFragment on User {
    id
    provider
    email
    firstName
    lastName
    phoneNumber
    phoneNumberVerified
    dateOfBirth
    language
    residenceStatus
    countryOfCitizenship
    status
    termsAccepted
    tradeConfirmationsAgreementAccepted
    userAddress {
      id
      unitNo
      street
      city
      state
      country
      postalCode
    }
    userFinancialProfile {
      id
      investmentPriority
      investmentHorizon
      downturnReaction
      employmentStatus
      employerName
      employerAddressUnitNo
      employerAddressStreet
      employerAddressCity
      employerAddressState
      employerAddressCountry
      employerAddressPostalCode
      occupationTitle
      occupationIndustry
      isFinraAffiliated
      isPoliticallyExposed
      isFamilyPoliticallyExposed
      trustedContactFirstName
      trustedContactLastName
      trustedContactEmail
      trustedContactPhoneNumber
      trustedContactAddressUnitNo
      trustedContactAddressStreet
      trustedContactAddressCity
      trustedContactAddressState
      trustedContactAddressCountry
      trustedContactAddressPostalCode
    }
    userTaxProfiles {
      id
      taxId
      taxIdType
      countryOfTaxResidence
      stateOfTaxResidence
    }
  }
`;

export const BENEFICIARIES_FRAGMENT = gql`
  ${GOAL_FRAGMENT}
  fragment BeneficiariesFragment on Beneficiary {
    id
    type
    firstName
    lastName
    dateOfBirth
    goals {
      ...GoalFragment
    }
  }
`;
